import type { Severity, Priority } from "../types/interfaces";

// Severity = business impact set at intake; priority = urgency used to order work.
export const SEVERITIES: Severity[] = ["critical", "major", "minor", "trivial"];
export const PRIORITIES: Priority[] = ["urgent", "high", "medium", "low"];

export const SEVERITY_LABEL: Record<Severity, string> = {
  critical: "Critical",
  major: "Major",
  minor: "Minor",
  trivial: "Trivial",
};
export const PRIORITY_LABEL: Record<Priority, string> = {
  urgent: "Urgent",
  high: "High",
  medium: "Medium",
  low: "Low",
};

export const SEVERITY_OPTIONS = SEVERITIES.map((v) => ({ value: v, label: SEVERITY_LABEL[v] }));
export const PRIORITY_OPTIONS = PRIORITIES.map((v) => ({ value: v, label: PRIORITY_LABEL[v] }));

// lower = more important; used to sort lists
export const SEVERITY_ORDER: Record<Severity, number> = { critical: 0, major: 1, minor: 2, trivial: 3 };
export const PRIORITY_ORDER: Record<Priority, number> = { urgent: 0, high: 1, medium: 2, low: 3 };
